import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientAllergies = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const userName = localStorage.getItem("kinesin-name");

  return useQuery({
    queryKey: ["allergies", patientId],
    queryFn: async () => {
      if (!patientId) return [];
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/allergy/getbyallergytype/ALLERGY/bypatient/${patientId}`
      );
      return response.data
        .map((item) => ({ ...item, entry: userName }))
        .filter((item) => item.allergyType === "ALLERGY");
    },
    enabled: !!patientId && !!tenantVal,
  });
};
